
// export const myGetter = ( state ) => {
//  return state
// }

export const municipalitiesList = state => state.municipalities
export const municipalitiesSelectable = state => state.municipalitiesSelectable
export const municipalitiesPaginatedData = state => state.municipalitiesPaginatedData
export const municipality = state => state.municipality
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData